<script>
  import ModalMensagem from '~componentes/ModalMensagem.vue';

  export default {
    components: { ModalMensagem  },
    props: {
      pedidos: {
        required: true
      },
      filtros: {
        required: false
      },
    },
    data() {
      return {
        animated: false,
        configuracao: this.$storage.configuracao(),
        modalMensagem: false,
        solicitacaoSelecionada: null,
      }
    },
    methods: {
      mostrarModalMensagem(solicitacao) {
        this.solicitacaoSelecionada = solicitacao;
        this.modalMensagem = true;
      },
      modalMensagensFechado() {
        this.animated = false;
        this.modalMensagem = false;
        this.solicitacaoSelecionada = null;
      },
    },
    computed: {
    }
  }
</script>

<template> 

  <div class="group">
    <modal-mensagem :mostrar="modalMensagem"
                    :id="solicitacaoSelecionada ? solicitacaoSelecionada.idSolicitacao : ''"
                    :numero="solicitacaoSelecionada ? solicitacaoSelecionada.idSolicitacaoCompra : ''"
                    tipo="SolCompra"
                    @fechado="modalMensagensFechado">
    </modal-mensagem>

    <div class="table-responsive">
      <table class="table table-bordered table-column-code table-column-action">
        <thead>
          <tr>
            <th>Solicitação compra</th>
            <th>Número pedido</th>
            <th>Data pedido</th>
            <th>Fornecedor</th>
            <th>Documento</th>
            <th>Projeto</th>
            <th>Valor total</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(pedido, index) in pedidos">
            <td>{{ pedido.idSolicitacaoCompra }}</td>
            <td>{{ pedido.numeroPedidoCompra || '---' }}</td>
            <td>{{ pedido.dataPedido || '---' }}</td>
            <td>{{ pedido.fornecedor || '---' }}</td>
            <td>{{ pedido.documento || '---' }}</td>
            <td>{{ pedido.nomeProjeto || '---' }}</td>
            <td>{{ pedido.valorPedido | formatarNumero }}</td>
            <td>
              <router-link class="btn btn-primary btn-xs"
                           active-class=""
                           v-tooltip="'Visualizar e liberar'"
                           :to="{ name: 'liberar-pedidos-compra.relatorio', params: { id: pedido.idPedido, filtrosBag: filtros } }">
                <i class="fa fa-file-text-o"></i>
              </router-link>

              <button type="button"
                      class="btn btn-success btn-xs"
                      v-tooltip="'Ler\Enviar mensagem'"
                      @click="mostrarModalMensagem(pedido)"
                      v-if="!configuracao.naoUtilizarMensageria">
                <i class="fa fa-comment"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/liberar-pedidos-compras/componentes/compartilhado/LiberarPedidoCompraLista.vue